export default __webpack_public_path__ + "8c3cad77b8e62ed3bca1613cdcc0ee20.svg";